<template>
    <ul
        v-if="result?.listings?.length > 0"
        class="house-grid layout1"
        :class="['count_' + result?.listings?.length]"
    >
        <house
            v-for="(item, index) in result.listings"
            :key="item.detailLink"
            :house="item"
        ></house>
    </ul>
</template>

<script>
import HouseGrid from '../house-grid';
import house from './house.vue';
export default {
    mixins: [HouseGrid],
    components: {
        house
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
.house-grid.layout1 {
    display: grid;
    grid-gap: 0 16px;
    position: relative;
    @media (min-width: 901px) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 601px) and (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 601px) {
        &.count_2 {
            grid-template-columns: repeat(2, 1fr);
        }
        &.count_1 {
            display: flex;
            justify-content: center;
            .house-grid-item {
                width: 50%;
            }
        }
    }
    @include media-600 {
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>
